export type Tenant = "starcheck" | "log" | "vlx" | "tokyo";

export const ACTIVE_TENANT: Tenant =
  (process.env.REACT_APP_PROJECT as Tenant) ?? "log";

export const TENANT_BG_CLASSES: Record<Tenant, string> = {
  starcheck: "bg-[#266BF0]",
  log: "bg-[#50D05D]",
  vlx: "bg-[#000000]",
  tokyo: "bg-[#E42E30]",
};

export const TENANT_TEXT_CLASSES: Record<Tenant, string> = {
  starcheck: "text-[#266BF0]",
  log: "text-[#50D05D]",
  vlx: "text-[#000000]",
  tokyo: "text-[#E42E30]",
};

export const TENANT_BORDER_CLASSES: Record<Tenant, string> = {
  starcheck: "border-[#266BF0]",
  log: "border-[#50D05D]",
  vlx: "border-[#000000]",
  tokyo: "border-[#E42E30]",
};

export const TENANT_BG_LIGHT_CLASSES: Record<Tenant, string> = {
  starcheck: "bg-[#E0EBFF]",
  log: "bg-[#E9FFF2]",
  vlx: "bg-[#DBDBDB]",
  tokyo: "bg-[#FFE2E2]",
};

export const TENANT_BG_HOVER_CLASSES: Record<Tenant, string> = {
  starcheck: "bg-[#266BF0]/10",
  log: "bg-[#50D05D]/10",
  vlx: "bg-[#000000]/10",
  tokyo: "bg-[#E42E30]/10",
};

export const TENANT_PEER_CHECKED_BG_CLASSES: Record<Tenant, string> = {
  starcheck: "peer-checked:bg-[#266BF0]",
  log: "peer-checked:bg-[#50D05D]",
  vlx: "peer-checked:bg-[#000000]",
  tokyo: "peer-checked:bg-[#E42E30]",
};
